export default "__VITE_ASSET__rjcMqxjJ__"